<template>
  <ul class="library-list">
    <slot />
  </ul>
</template>

<style lang="less" scoped>
.library-list {
  border: 1px solid @stroke-default;
  padding: 0px;
  border-top: none;
  background-color: @white;
  border-bottom-left-radius: 8px;
  border-bottom-right-radius: 8px;
  list-style-type: none;
  overflow: hidden;
  margin-bottom: 24px;
}
</style>
